import React, { useRef } from "react";

const UpdateColumnModal = ({handleCancel, MAX_COLUMNS=8, tempSelectedColumns, ALL_COLUMNS, handleResetToDefault, handleApplyChanges, handleColumnToggle}) => {
  const scrollRef = useRef(null);

  const onColumnToggle = (key) => {
    handleColumnToggle(key);
    if (!tempSelectedColumns.includes(key) && tempSelectedColumns.length >= MAX_COLUMNS) {
      scrollRef.current?.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
      <div className="bg-white rounded-xl w-[90%] max-w-xl max-h-[80vh] overflow-hidden shadow-xl">
        <div className="flex justify-between items-center px-6 py-4 border-b border-slate-200">
          <h3 className="m-0 text-lg font-semibold text-gray-900">
            Customize Table Columns
          </h3>
          <button
            className="bg-transparent border-none text-xl cursor-pointer text-slate-500 p-1 hover:text-slate-700"
            onClick={handleCancel}
          >
            ✕
          </button>
        </div>
        <div ref={scrollRef} className="px-6 py-4 max-h-96 overflow-y-auto">
          <p className="m-0 mb-2 text-slate-500 text-sm">
            Select the columns you want to display in the table:
          </p>
          {tempSelectedColumns.length >= MAX_COLUMNS && (
            <p className="m-0 mb-3 text-red-500 text-sm font-medium">
              ⚠️ Maximum {MAX_COLUMNS} columns allowed. Deselect a column to
              select another.
            </p>
          )}
          <p className="m-0 mb-4 text-slate-400 text-xs">
            {tempSelectedColumns.length}/{MAX_COLUMNS} columns selected
          </p>
          <div className="grid grid-cols-2 gap-3">
            {ALL_COLUMNS.map((col) => (
              <label
                key={col.key}
                className="flex items-center gap-2.5 px-3 py-2.5 bg-slate-50 rounded-md cursor-pointer hover:bg-slate-100 transition-colors duration-150"
              >
                <input
                  type="checkbox"
                  checked={tempSelectedColumns.includes(col.key)}
                  onChange={() => onColumnToggle(col.key)}
                  className="w-4.5 h-4.5 cursor-pointer accent-indigo-600"
                />
                <span className="text-sm text-slate-700">{col.label}</span>
              </label>
            ))}
          </div>
        </div>
        <div className="flex justify-between items-center px-6 py-4 border-t border-slate-200 bg-slate-50">
          <button
            className="px-4 py-2.5 bg-transparent text-slate-500 border border-slate-200 rounded-md cursor-pointer text-sm hover:bg-slate-100 transition-colors duration-150"
            onClick={handleResetToDefault}
          >
            Reset to Default
          </button>
          <div className="flex gap-3">
            <button
              className="px-4 py-2.5 bg-white text-slate-700 border border-slate-200 rounded-md cursor-pointer text-sm hover:bg-slate-50 transition-colors duration-150"
              onClick={handleCancel}
            >
              Cancel
            </button>
            <button
              className="px-5 py-2.5 bg-[#474747] text-white border-none rounded-md cursor-pointer text-sm font-medium hover:bg-[#a67a1b] disabled:bg-indigo-300 disabled:cursor-not-allowed transition-colors duration-150"
              onClick={handleApplyChanges}
              disabled={tempSelectedColumns.length === 0}
            >
              Apply Changes
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UpdateColumnModal;